export interface IUserParent {
  id?: string;
  lastName?: string | null;
  firstName?: string | null;
  telephone?: number;
  activated?: boolean;
  parentId?: string;
  userId?: string;
}

export const defaultParentValue: Readonly<IUserParent> = {
  id: null,
  lastName: '',
  firstName: '',
  telephone: null,
  activated: true,
  parentId: null,
  userId: null,
};
